import React from 'react'
import axios from 'axios'

const {
    REACT_APP_DATABASE_BASEURL_DEV,
    REACT_APP_DATABASE_BASEURL,
    REACT_APP_NODE_ENV
} = process.env;

const DeleteMeModal = ({
    generateHeaderCloseIco,
    socket,
    modalTitle,
    handleKickUser,
    me
}) => {

    const [infoMessage, setInfoMessage] = React.useState('')
    const [reportComment, setReportComment] = React.useState('')


    const handleReportChange = (e) => {
        setReportComment(e.target.value)
    }

    const startDeletingUser = async () => {
        try {
            const response = await axios.delete(`${REACT_APP_NODE_ENV === 'development' ?
                REACT_APP_DATABASE_BASEURL_DEV :
                REACT_APP_DATABASE_BASEURL}/delete-user/${me.name}`, {
                headers: {
                    'authorization': localStorage.getItem('token')
                }
            })

            if (response.data.status === 1) {
                setInfoMessage('User deleted')
                socket.emit('rifreshAll', me.name, me.avatar)
                handleKickUser(me.name)
            } else {
                setInfoMessage(response.data.message)
            }
        } catch (e) {
            setInfoMessage('Nešto je pošlo po zlu')
        }
    }

    const generateReportForm = () => {
        return (
            <div className="column p-right-20">
                {infoMessage.length !== 0 && <p className="form-p mediumaquamarine margin-top">{infoMessage}</p>}
                {infoMessage.length === 0 && <div className="margin-bottom w100 margin-top">
                    <p className="form-p margin-bottom">{`Dragi/a ${me.name}, žao mi je što odlaziš. Ova radnje će obrisati tvoj profil, privatne poruke, shoutove, vijesti, pjesme i više nećeš bit u matchmakingu bez mogućnosti poništenja. Molim te da ukratko navedeš napišeš razlog za odlazak. Hvala.`}</p>

                    <div className="form-item margin-bottom">
                        <input
                            type="text"
                            style={{ borderColor: 'mediumAquaMarine'}}
                            value={reportComment}
                            onChange={handleReportChange}
                            className="mm-input w100"
                            id="Repoprt"
                            name="Report"
                            placeholder='Razlog za prijavu'
                        />
                    </div>
                    {reportComment.length !== 0 && <p className="form-p"><span><em>Razlog za brisanje</em></span></p>}

                    <button onClick={startDeletingUser} className="content-button w30 margin-top">
                        Obriši profil
                    </button>
                </div>}
            </div>
        )
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title margin-bottom">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {generateReportForm()}
                </div>

            </div>
        </div>
    )
}

export default DeleteMeModal